import { defaultTagsFilter } from "./helpers";

const config = {
  globalScope: true,
  "app": {
    "database": {
      "notificationDB": "ethinking-notification",
      "notificationTable": "notification",
      "resubTable": "resub",
      "version": 1,
      "notificationMaxResults": 50,
    },
    "localStorage": {
      "deviceStorageKey": "pushDelivery.device",
      "lastTokenUpdateKey": "pushDelivery.lastTokenUpdate",
      "ttl": 1000 * 60 * 60 * 24 * 30, // 30 days
      // 'migration': migrateLocalStorage
    },
  },
  ui: {
    color: "#ffffff",
    icon: "blank.gif",
    translations: {
      "de": {
        "settings": {
          "label_subscribed": "Sie sind für Benachrichtigungen angemeldet.",
          "label_blocked": "Bitte Benachrichtigungen im Browser erlauben",
          "label_subscribe": "Für Benachrichtigungen anmelden",
        },
        "sidebar": {
          "message_list_empty": "Keine Benachrichtigungen vorhanden.",

          "tab_notification": "Meldungen",
          "tab_settings": "Meine Themen",

          "label_language": "Sprache wählen:",
          "label_description": "Sie erhalten Benachrichtigungen für:",
          "label_tag_selection": "Themenbereich wählen",

          "button_unsubscribe": "Von allen Benachrichtigungen abmelden",
          "button_save": "Speichern",
          "button_close": "Schliessen",
        },
        "askForPermissionsDialog": {
          "label_description": "Möchten Sie künftig direkt per Browser-Benachrichtigung über die wichtigsten Nachrichten informiert werden?",
          "button_confirm": "Ja",
          "button_deny": "Nein",
        },
        "howToUnblockDialog": {
          "image": {
            "chrome": "unblock-chrome-german.gif",
            "firefox": "unblock-FF-german.gif",
          },
          "label_title": "Blockierung jetzt aufheben",
          "label_description": "So können Sie die Blockierung schnell und einfach aufheben. Danach laden Sie die Seite bitte neu.",
        },
        "confirm": {
          "label_text": "Sind Sie sich sicher?",
        },
        "tagGroupLabels": {
          "browser_german": "Deutsch",
          "browser_italian": "Italienisch",
          "browser_french": "Französisch",
        },
      },
      "fr": {
        "settings": {
          "label_subscribed": "Vous avez activé les notifications",
          "label_blocked": "Merci d'autoriser les notifications du navigateur",
          "label_subscribe": "Activer les notifications",
        },
        "sidebar": {
          "message_list_empty": "Aucune notification disponible.",

          "tab_notification": "Notifications",
          "tab_settings": "Paramètres",

          "label_language": "Sélectionner la langue",
          "label_description": "",
          "label_tag_selection": "Sélectionner un thème",

          "button_unsubscribe": "Se désabonner de toutes les notifications",
          "button_save": "Sauvegarder",
          "button_close": "Fermer",
        },
        "askForPermissionsDialog": {
          "label_description": "À l'avenir, souhaitez-vous être informé des principales actualités par notification de votre navigateur?",
          "button_confirm": "Oui",
          "button_deny": "Non",
        },
        "howToUnblockDialog": {
          "image": {
            "chrome": "unblock-chrome-french.gif",
            "firefox": "unblock-FF-french.gif",
          },
          "label_title": "Débloquer maintenant",
          "label_description": "Voici comment annuler rapidement et facilement le blocage. Rafraîchir ensuite la page.",
        },
        "confirm": {
          "label_text": "Êtes-vous sûr?",
        },
        "tagGroupLabels": {
          "browser_german": "Allemand",
          "browser_italian": "Italien",
          "browser_french": "Français",
        },
      },
      "it": {
        "settings": {
          "label_subscribed": "Avete attivato le notifiche",
          "label_blocked": "Autorizzare le notifiche sul browser",
          "label_subscribe": "Attivare le notifiche",
        },
        "sidebar": {
          "message_list_empty": "Nessuna notifica disponibile.",

          "tab_notification": "Notifiche",
          "tab_settings": "Impostazioni",

          "label_language": "Selezionare la lingua",
          "label_description": "",
          "label_tag_selection": "Selezionare un tema",

          "button_unsubscribe": "Annullare l'abbonamento a tutte le notifiche",
          "button_save": "Salvare",
          "button_close": "Chiudere",
        },
        "askForPermissionsDialog": {
          "label_description": "In futuro, volete essere informati delle principali novità attraverso le notifiche sul vostro browser?",
          "button_confirm": "Sì",
          "button_deny": "No",
        },
        "howToUnblockDialog": {
          "image": {
            "chrome": "unblock-chrome-italian.gif",
            "firefox": "unblock-FF-italian.gif",
          },
          "label_title": "Sbloccare ora",
          "label_description": "Ecco come annullare il blocco rapidamente e facilmente. Aggiorna la pagina.",
        },
        "confirm": {
          "label_text": "È sicuro?",
        },
        "tagGroupLabels": {
          "browser_german": "Tedesco",
          "browser_italian": "Italiano",
          "browser_french": "Francese",
        },
      },
      "en": {
        "button_close": "Close",
        "sidebar_tab_settings": "Settings",
      },
      "es": {
        "settings": {
          "label_subscribed": "Está suscrito a las notificaciones.",
          "label_blocked": "Por favor, permita las notificaciones en el navegador",
          "label_subscribe": "Suscribirse a las notificaciones",
        },
        "sidebar": {
          "message_list_empty": "No hay notificaciones disponibles.",
          "tab_notification": "Notificaciones",
          "tab_settings": "Mis Temas",
          "label_language": "Seleccionar idioma:",
          "label_description": "Recibirá notificaciones para:",
          "label_tag_selection": "Seleccionar categoría de temas",
          "button_unsubscribe": "Cancelar suscripción a todas las notificaciones",
          "button_save": "Guardar",
          "button_close": "Cerrar",
        },
        "askForPermissionsDialog": {
          "label_description": "¿Le gustaría recibir notificaciones del navegador sobre las noticias más importantes?",
          "button_confirm": "Sí",
          "button_deny": "No",
        },
        "howToUnblockDialog": {
          "image": {
            "chrome": "unblock-chrome-spanish.gif",
            "firefox": "unblock-FF-spanish.gif",
          },
          "label_title": "Desbloquear ahora",
          "label_description": "Así es como puede desbloquear rápidamente. Luego, por favor, recargue la página.",
        },
        "confirm": {
          "label_text": "¿Está seguro?",
        },
        "tagGroupLabels": {
          "browser_german": "Alemán",
          "browser_italian": "Italiano",
          "browser_french": "Francés",
        },
      },
      "defaultLanguage": "de",
    },
    "template": {
      "modal": {
        "logo": "https://showcase-ez.ethinking.de/bundles/ezplatformpushconnector/img/push-delivery-logo.jpg",
      },
      "bell": {
        "image": "https://push.delivery.ethinking.de/bluewin/images/bluewin-wheel.svg",
      },
    },
  },
};
export default config;
